const BRANDING_CUSTOM_COLORS = [
  '#000000',
  '#000080',
  '#0000FF',
  '#003300',
  '#003366',
  '#008000',
  '#008080',
  '#00CCFF',
  '#00FF00',
  '#1a3e94',
  '#333300',
  '#333333',
  '#333399',
  '#3366FF',
  '#339966',
  '#33CCCC',
  '#666699',
  '#800000',
  '#800080',
  '#808000',
  '#808080',
  '#993300',
  '#993366',
  '#99CC00',
  '#c7202b',
  '#e43933',
  '#FF0000',
  '#FF00FF',
  '#FF6600',
  '#FF9900',
  '#FFCC00',
];

const lessColors = {
  'grey-100': '#F6F6F6',
  'grey-200': '#EEEEEE',
  'grey-300': '#E0E0E0',
  'grey-400': '#C3C3C3',
  'grey-550': '#909090',
  'grey-700': '#666666',
  'grey-850': '#4C4C4C',
  'grey-1000': '#262626',
  'grey-1100': '#000000',

  'cool-grey-100': '#EEF8FD',
  'cool-grey-200': '#E6F0F5',
  'cool-grey-300': '#D8E2E7',
  'cool-grey-400': '#BBC5CA',
  'cool-grey-500': '#A2ACB1',
  'cool-grey-600': '#788287',
  'cool-grey-700': '#5E686D',
  'cool-grey-800': '#4D575C',
  'cool-grey-900': '#3C464B',
  'cool-grey-1000': '#1E282D',

  'sky-blue-200': '#DCF4FF',
  'sky-blue-300': '#C0EAFF',
  'sky-blue-400': '#8BD5F9',
  'sky-blue-500': '#72BCE0',
  'sky-blue-600': '#4892B6',
  'sky-blue-700': '#2E789C',
  'sky-blue-800': '#1D678B',
  'sky-blue-900': '#0C567A',
  'sky-blue-1000': '#00324B',

  'blue-300': '#C9E6FF',
  'blue-400': '#97CFFF',
  'blue-500': '#6FB8F8',
  'blue-600': '#4791CE',
  'blue-700': '#2C76B3',
  'blue-800': '#1B64A3',
  'blue-900': '#00447F',
  'blue-1000': '#002F59',

  'green-100': '#EAFFD7',
  'green-200': '#D6FFB0',
  'green-300': '#B5FF70',
  'green-400': '#97E34F',
  'green-500': '#7DCA36',
  'green-600': '#6BA03A',
  'green-700': '#3F8200',
  'green-800': '#356E00',
  'green-900': '#2A5700',
  'green-1000': '#173000',

  'yellow-100': '#FFFCBD',
  'yellow-200': '#FFF983',
  'yellow-300': '#FFF41D',
  'yellow-400': '#E2D700',
  'yellow-500': '#C5BC00',

  'orange-100': '#FFF4E9',
  'orange-200': '#FFEAD5',
  'orange-300': '#FFD9B2',
  'orange-400': '#FFB56A',
  'orange-500': '#FF8000',
  'orange-600': '#D76C00',
  'orange-700': '#AB5600',
  'orange-800': '#8F4800',
  'orange-900': '#723900',

  'red-100': '#FFF3F0',
  'red-200': '#FFE9E3',
  'red-300': '#FFD6CC',
  'red-400': '#FFAC9A',
  'red-500': '#FF896F',
  'red-650': '#FF4016',
  'red-800': '#D02600',
  'red-900': '#A71E00',

  // shipengine only colors
  'purple-100': '#f8f0ff',
  'purple-200': '#f2e3ff',
  'purple-300': '#e8ccff',
  'purple-400': '#d0a3f8',
  'purple-500': '#b78ade',
  'purple-600': '#8d60b5',
  'purple-700': '#724599',
  'purple-800': '#62348a',
  'purple-900': '#502278',

  'bright-blue-200': '#b9eaff',
  'bright-blue-300': '#72d5ff',
  'bright-blue-400': '#43c1f7',
  'bright-blue-500': '#3cadde',
  'bright-blue-600': '#318db5',
  'bright-blue-700': '#297799',

  'electric-blue-400': '#4380e8',
  'electric-blue-500': '#3a6fc9',
  'electric-blue-600': '#3361b0',
  'electric-blue-700': '#274a87',
  'electric-blue-800': '#1f3c6e',
  'electric-blue-900': '#142645',
  'electric-blue-1000': '#0c172b',
  'electric-blue-1100': '#040b17',

  'split-ship-background': '#FFFEEF',
  'split-ship-border': '#DDDBC0',

  white: '#fff',
  black: '#000',
};

export default class ColorService {
  static getBrandingCustomColors() {
    return BRANDING_CUSTOM_COLORS;
  }

  static getLessColor(colorName) {
    const matchingColor = lessColors[colorName];
    if (matchingColor === undefined) {
      return '#000';
    }
    return matchingColor.toUpperCase();
  }

  static getLessColors() {
    return lessColors;
  }

  static hexToIntColor(hexString) {
    let formattedHexString = hexString.replace('#', '').trim();
    if (formattedHexString.length === 3) {
      formattedHexString = `${formattedHexString[0]}${formattedHexString[0]}${formattedHexString[1]}${formattedHexString[1]}${formattedHexString[2]}${formattedHexString[2]}`;
    }
    if (formattedHexString.length !== 6) {
      return undefined;
    }
    const red = parseInt(formattedHexString.substr(0, 2), 16);
    const green = parseInt(formattedHexString.substr(2, 2), 16);
    const blue = parseInt(formattedHexString.substr(4, 2), 16);

    if (Number.isNaN(red) || Number.isNaN(green) || Number.isNaN(blue)) {
      return undefined;
    }

    return {
      red,
      green,
      blue,
    };
  }

  static shouldUseWhiteText(hexString) {
    const colorObject = this.hexToIntColor(hexString);
    if (colorObject === undefined) {
      return;
    }
    return this.calculateLuminance(colorObject) < 0.45;
  }

  static calculateLuminance({ red = 0, blue = 0, green = 0 }) {
    return (0.299 * red + 0.587 * green + 0.114 * blue) / 256;
  }

  static isValidHexCode(hexString) {
    const regex = new RegExp(/^#([0-9A-F]{3}){1,2}$/i);
    return regex.test(hexString);
  }
}
